<template>
  <transition name="c-gnav">
  <div v-show="$store.getters.isShowGnav" class="c-gnav">
    <div class="c-gnav__btn" @click="closeNav">
      <transition name="c-cross">
      <div v-show="$store.getters.isShowGnav" class="c-cross">
        <div class="c-cross__wrap">
          <span></span>
          <span></span>
        </div>
      </div>
      </transition>
    </div>

    <div class="c-gnav__wrap">
      <div class="c-gnav__head">
        <div class="c-gnav__headLogo">
          <img :src="`${assets_path}img/common/logo.svg`" alt="I LADY" width="191" height="58">
        </div>
      </div>

      <div class="c-gnav__links">
        <ul>
          <li><a href="/">TOP</a></li>
          <li><a href="/interview/">I LADY. な人たち</a></li>
          <li><a href="/data/survey2019/"><span>知る I LADY.</span>性と恋愛 2019</a></li>
          <li><a href="/data/srhr/"><span>知る I LADY.</span>SRHR DATA</a></li>
          <li><a href="/contents/?contents_category=workshop,event">参加する I LADY.</a></li>
          <li><a href="/contents/?contents_category=report">I LADY. REPORT</a></li>
          <li><a href="/item/">I LADY. アイテム</a></li>
          <li><a href="/about/">I LADY. について</a></li>
          <li><a href="/link/"><span>I LADY. 推奨</span>情報サイト・窓口</a></li>
        </ul>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
  import { breakpoint, assets_path } from '@/_modules/utils/variables';
  import store from '@/_modules/stores';

  export default {
    components: {

    },
    data() {
      return {
        assets_path: assets_path
      }
    },
    store,
    computed: {
    },
    created() {

    },
    mounted() {
    },
    methods: {
      closeNav() {
        this.$store.commit('setShowGnav', false);
        this.$el.scrollTop = 0;
      }
    }
  }
</script>
